import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 40px;
  height: 40px;
  color: #d2341c;
`

const Alert = ({ title = 'Alert', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 64 64" title={title} {...rest}>
    <g className="nc-icon-wrapper" fill="currentColor">
      <polygon
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeMiterlimit="10"
        points="4,60 32,8 60,60 "
        strokeLinejoin="miter"
      />{' '}
      <line
        data-color="color-2"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeMiterlimit="10"
        x1="32"
        y1="28"
        x2="32"
        y2="43"
        strokeLinejoin="miter"
      />{' '}
      <circle
        data-color="color-2"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeMiterlimit="10"
        cx="32"
        cy="50"
        r="1"
        strokeLinejoin="miter"
      />{' '}
      <circle
        data-color="color-2"
        data-stroke="none"
        fill="currentColor"
        cx="32"
        cy="50"
        r="1"
        strokeLinejoin="miter"
        strokeLinecap="square"
      />
    </g>
  </StyledIcon>
)

Alert.displayName = 'Alert'
Alert.needsWork = true
export default Alert
